import { render } from "./ProductCreator.vue?vue&type=template&id=d215e24e&scoped=true"
import script from "./ProductCreator.vue?vue&type=script&lang=js"
export * from "./ProductCreator.vue?vue&type=script&lang=js"

import "./ProductCreator.vue?vue&type=style&index=0&id=d215e24e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d215e24e"]])

export default __exports__